import Choices from 'choices.js';

/**
 * Initialize Choices.js selects
 *
 * @param {string} selector
 * @param {object} [options]
 * @returns {Choices[]}
 */
// eslint-disable-next-line import/prefer-default-export
export function initChoices(selector, options = {}) {
    const elements = document.querySelectorAll(selector);

    if (!elements.length) {
        return [];
    }

    return [...elements].map(element => new Choices(element, {
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: '',
        allowHTML: false,
        ...options,
    }));
}

/**
 * Usage example
 *
 * import { initChoices } from 'utils/choices';
 *
 * initChoices('.js-select');
 */